export default {"src":"/_next/static/media/prmm.f71c872f.svg","height":71,"width":60,"blurWidth":0,"blurHeight":0};